import { i18n } from '@/i18n'
import store from '@/store'
export default () => {
  const role = store.getters['auth/role']

  const hasModuleAgrupaciones = store.getters['auth/hasAgrupacionesModule']
  
  const hasAnyPersonalizationModule = store.getters['auth/hasAnyPersonalizationModule']
  const hasModuleXSLT = store.getters['auth/hasXsltModule']
  const hasModuleWebHooks = store.getters['auth/hasAnyWebHooksModule']
  const hasModuleVerifactu = store.getters['auth/hasVerifactuModule']
  const hasModuleReceivedInvoice = store.getters['auth/hasReceivedInvoiceModule']
  const hasModuleIssuedInvoice = store.getters['auth/hasIssuedInvoiceModule']
  const hasModuleApprovalWorkflow = store.getters['auth/hasApprovalWorkflowModule']
  const hasModuleInmatic = store.getters['auth/hasInmaticModule']

  const invoices = []

  const hasAnyImportaciones = store.getters['auth/hasAnyImportaciones']

  if (hasModuleIssuedInvoice) {
    invoices.push({
      menuId: 1,
      icon: 'issued',
      name: i18n.t('invoices.issued_header'),
      path: 'invoicesissued',
      registerNavFromMenu: true,
      sc: [] // Child options
    })
  }
  if (role !== 9 && hasModuleReceivedInvoice) {
    invoices.push({
      menuId: 2,
      icon: 'recived',
      name: i18n.t('invoices.received_header'),
      path: 'invoicesreceived',
      registerNavFromMenu: true,
      sc: [] // Child options
    })
  }

  const verifactu = [
    {
      menuId: 14,
      icon: 'verifactu',
      name: i18n.t('tipos.modulo_name.verifactu'),
      path: 'verifactu',
      registerNavFromMenu: true,
      sc: []
    }
  ]

  const masters = [
    {
      menuId: 3,
      icon: 'maestros',
      name: i18n.t('masters.header'),
      path: 'masters',
      registerNavFromMenu: true,
      sc: [
        {
          icon: 'chevronright',
          name: i18n.t('agenda.sociedad_plural'),
          path: 'masters/society',
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          icon: 'chevronright',
          name: i18n.t('impuestos.header'),
          path: 'masters/impuestos',
          registerNavFromMenu: false,
          sc: [] // shorcuts
        }, 
        {
          icon: 'chevronright',
          name: i18n.t('products.header'),
          path: 'masters/products',
          registerNavFromMenu: false,
          sc: [] // shorcuts
        }
      ] 
    }
  ]
  
  const menu = [
    {
      menuId: 4,
      icon: 'companies',
      name: i18n.t('companies.header'),
      path: 'companies',
      registerNavFromMenu: true,
      sc: [] // Child options
    },
  ]

  if (role !== 9) {
    menu.push({
      menuId: 5,
      icon: 'certificates',
      name: i18n.t('certificates.header'),
      path: 'certificates',
      registerNavFromMenu: true,
      sc: [] // Child options
    })
  } else {
    menu[0].path = 'masters'
  }

  if (role !== 7) {
    if (!(role === 4 || role === 9)) {
      menu.unshift(...masters)
    }
    if (hasModuleVerifactu && role !== 9) {
      menu.unshift(...verifactu)
    }
    menu.unshift(...invoices)
  }

  if (role !== 1 && role !== 4 && role !== 9) {
    const config = {
      menuId: 6,
      icon: 'config',
      name: i18n.t('configurations.header'),
      path: role === 3 ? 'configurationssa' : 'configurations',
      registerNavFromMenu: true,
      sc: [
        {
          icon: 'chevronright',
          name: i18n.t('users.header'),
          path: 'configurations/users',
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          icon: 'chevronright',
          name: i18n.t('groups.header'),
          path: 'configurations/groups',
          registerNavFromMenu: false,
          sc: [] // shorcuts
        }
      ] // Child options
    }
    const configDistributors = {
      icon: 'chevronright',
      name: i18n.t('distributors.header'),
      path: 'configurations/distributors',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configClients = {
      icon: 'chevronright',
      name: i18n.t('clients.header'),
      path: 'configurations/clients',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configGeneral = {
      icon: 'chevronright',
      name: i18n.t('app.config_general'),
      path: 'configurations/general',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configGrouping = {
      icon: 'chevronright',
      name: i18n.t('grouping.header'),
      path: 'configurations/grouping/companies/main',
      registerNavFromMenu: true,
      sc: [] // shorcuts
    }
    const configTemplateClientsPersonalization = {
      icon: 'chevronright',
      name: i18n.t('distributors.template_clients_personalization'),
      path: 'configurations/template/clientspersonalization',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configPersonalization = {
      icon: 'chevronright',
      name: i18n.t('personalization.header'),
      path: 'configurations/personalization',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configRules = {
      icon: 'chevronright',
      name: i18n.t('rules.distribution_rules'),
      path: 'configurations/rules',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configApprovalWorkflow = {
      icon: 'chevronright',
      name: i18n.t('approval_workflow.header'),
      path: 'configurations/approvalworkflows',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configTemplateClientsPdfTemplate = {
      icon: 'chevronright',
      name: i18n.t('plantilla_pdf.header'),
      path: 'configurations/template/clientspdftemplate',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configPdftemplate = {
      name: i18n.t('plantilla_pdf.header'),
      path: 'configurations/pdftemplate',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
  
    const configWebHooks = {
      name: i18n.t('webhooks.header'),
      path: 'configurations/webhooks',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }

    const configTemplate = {
      icon: 'chevronright',
      name: i18n.t('clients.template'),
      path: 'configurations/template/companies',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configTemplateGroups = {
      icon: 'chevronright',
      name: i18n.t('clients.template_groups'),
      path: 'configurations/template/groups',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }

    const configImportaciones = {
      icon: 'chevronright',
      name: i18n.t('imports.imports'),
      path: 'configurations/imports',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    
    const configInmatic = {
      name: i18n.t('configInmatic.header'),
      path: 'configurations/configInmatic',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }

    if (role === 7 || role === 8 || role === 3) config.sc.unshift(configClients)
    if (role === 2 || role === 7 || role === 8) config.sc.unshift(configGeneral)
    config.sc.push(configRules)
    if (hasModuleApprovalWorkflow) {
      config.sc.push(configApprovalWorkflow) 
    }
    if (role === 2) {
      config.sc.push(configTemplate)
      config.sc.push(configTemplateGroups)
    }
    if (role === 2 && hasModuleAgrupaciones) config.sc.push(configGrouping) 
    if (role === 3) config.sc.unshift(configDistributors)

    if (hasAnyPersonalizationModule) { 
      if (role === 2) {
        config.sc.push(configPersonalization)
      } else if (role === 7 || role === 8) {
        config.sc.push(configTemplateClientsPersonalization) 
      }
    }
    if (hasModuleXSLT) {
      if (role === 2) {
        config.sc.push(configPdftemplate)
      } else if (role === 7 || role === 8) {
        config.sc.push(configTemplateClientsPdfTemplate)
      }
    }
    if (hasModuleWebHooks) {
      if (role === 2) {
        config.sc.push(configWebHooks)
      }
    }
    if (hasModuleInmatic) {
      if (role === 2) {
        config.sc.push(configInmatic)
      }
    }
    if (hasAnyImportaciones) config.sc.push(configImportaciones)

    menu.push(config)
  }
  
  if (role !== 1 && role !== 4 && role !== 9) {
    const trash = {
      menuId: 7,
      icon: 'trash',
      name: i18n.t('trash.header'),
      path: role === 7 ? 'trashad' : 'trash',
      registerNavFromMenu: true,
      sc: [
        {
          icon: 'chevronright',
          name: i18n.t('companies.header'),
          path: 'trash/companies',
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          icon: 'chevronright',
          name: i18n.t('certificates.header'),
          path: 'trash/certificates',
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          icon: 'chevronright',
          name: i18n.t('users.header'),
          path: 'trash/users',
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          icon: 'chevronright',
          name: i18n.t('groups.header'),
          path: 'trash/groups',
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          icon: 'chevronright',
          name: i18n.t('agenda.sociedad_plural'),
          path: 'trash/society',
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          icon: 'chevronright',
          name: i18n.t('impuestos.header'),
          path: 'trash/impuestos',
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          icon: 'chevronright',
          name: i18n.t('products.header'),
          path: 'trash/products',
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
      ] // Child options
    }

    const trashInvoices = []
  
    if (hasModuleIssuedInvoice) {
      trashInvoices.push({
        icon: 'chevronright',
        name: i18n.t('invoices.issued_header'),
        path: 'trash/invoicesissued',
        registerNavFromMenu: false,
        sc: [] // shorcuts
      })
    }
    if (hasModuleReceivedInvoice) {
      trashInvoices.push({
        icon: 'chevronright',
        name: i18n.t('invoices.received_header'),
        path: 'trash/invoicesreceived',
        registerNavFromMenu: false,
        sc: [] // shorcuts
      })
    }
    
    if (role !== 7) {
      trash.sc.unshift(...trashInvoices)
    }
   
    menu.push(trash)
  }

  return menu
}

/*
  Menu ID

  1:  Facturas emitidas
  2:  Facturas recibidas
  3:  Maestros
  4:  Empresas
  5:  Certificados
  6:  Configruración
  7:  Papelera
  8:  Submenú facturas emitidas
  9:  Submenú facturas recibidas
  10: Cabecera sin enviar
  11: Cabecera enviada
  12: Cabecera error 
  13: Cabecera recibida
  14: Verifactu
  15: Cabecera registros
  16: Submenú verifactu

*/
